import { useState } from "react";
import { useEffect } from "react";
import { React } from "react";
import { Form, Col, Row } from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import { IconContext } from "react-icons";
import { IoInformationCircleOutline } from "react-icons/io5";
import IllustrationImage from "../shared/illustration-image/illustration-image.component";
import FormFooterButtons from "../../components/form-footer-buttons/form-footer-buttons.component";
import SectionTitle from "../section-title/section-title.component";
import { useMutation } from "@apollo/client";
import { FETCH_COUNTRY_FOR_PICKUP } from "../../services/graphql/businessAccount";
import SimpleGoogleAutocomplete from "../place-autocomplete/place-autocomplete.component";

const ServiceLocationForm = ({
  handleBackClick,
  handleNextClick,
  setServiceLocation,
  formValue,
}) => {
  const [validated, setValidated] = useState(false);

  const [newAddress, setNewAddress] = useState({
    address: "",
    cityName: "",
    stateName: "",
    countryName: "",
    streetName: "",
  });
  const [countryCode, setCountryCode] = useState(["us", "ca"]);

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }

    setValidated(true);

    if (form.checkValidity() === true) {
      setServiceLocation(newAddress);
      handleNextClick();
    }
  };

  const [fetchCountryForPickup] = useMutation(FETCH_COUNTRY_FOR_PICKUP, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: true,
    onCompleted: (data) => {
      if (data && data.fetchCountryForPickup) {
        const countryCode = data.fetchCountryForPickup;
        setCountryCode(countryCode);
      }
    },
  });

  useEffect(() => {
    if (formValue.serviceLocation && formValue.serviceLocation.address !== "") {
      setNewAddress(formValue.serviceLocation);
    }
    fetchCountryForPickup();
  }, []);

  return (
    <div>
      <div>
        <div
          style={{
            marginTop: "5%",
            backgroundColor: "#FFF3DA",
            padding: 16,
            marginRight: "5%",
          }}
        >
          <IconContext.Provider value={{ size: 22, color: "black" }}>
            <IoInformationCircleOutline />
          </IconContext.Provider>
          <label
            style={{
              fontSize: "16px",
              fontWeight: "500",
              color: "#545454",
              marginLeft: 10,
            }}
          >
            You won’t be able to edit this information later.
          </label>
        </div>
        <div style={{ marginTop: "5%", marginBottom: "3%" }}>
          <SectionTitle
            title={"What’s your location range?"}
            subtitle={
              "Specify which region you’ll be able to provide your services in person"
            }
          />
        </div>
      </div>
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <Row>
          <Col lg="6" md="6" sm="6" xs="6" style={{ paddingLeft: "0px" }}>
            <Col lg="6" md="6" sm="6" xs="6">
              <SimpleGoogleAutocomplete
                onSelect={(data) => {
                  setNewAddress(data);
                }}
                countryCodes={countryCode}
                initialValue={newAddress}
              />
            </Col>
            <div style={{ display: "flex", marginTop: "20px" }}>
              <Col
                md="4"
                lg="4"
                style={{ color: "#A6A6A6", paddingRight: "10px" }}
              >
                <Form.Group
                  controlId="validationCustom01"
                  style={{ color: "#A6A6A6" }}
                >
                  <Form.Label>Country / Region</Form.Label>
                  <Typeahead
                    id="typeahead-country"
                    labelKey={(option) => option}
                    onChange={(val) =>
                      setNewAddress((prev) => ({
                        ...prev,
                        country: val[0] || "",
                      }))
                    }
                    options={
                      newAddress.countryName ? [newAddress.countryName] : []
                    }
                    selected={
                      newAddress.countryName ? [newAddress.countryName] : []
                    }
                    placeholder="Country / Region"
                    disabled
                  />
                  <Form.Control.Feedback>
                    Please select a valid Country / Region.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col md="4" style={{ color: "#A6A6A6", paddingRight: "10px" }}>
                <Form.Group controlId="validationCustom01">
                  <Form.Label>State / Province</Form.Label>
                  <Typeahead
                    id="typeahead-state"
                    labelKey={(option) => option}
                    onChange={(val) =>
                      setNewAddress((prev) => ({
                        ...prev,
                        state: val[0] || "",
                      }))
                    }
                    options={newAddress.stateName ? [newAddress.stateName] : []}
                    selected={
                      newAddress.stateName ? [newAddress.stateName] : []
                    }
                    placeholder="State / Province"
                    disabled
                  />
                  <Form.Control.Feedback>
                    Please select a valid State / Province.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col md="4" style={{ color: "#A6A6A6" }}>
                <Form.Group controlId="validationCustom01">
                  <Form.Label>City</Form.Label>
                  <Typeahead
                    id="typeahead-city"
                    labelKey={(option) => option}
                    onChange={(val) =>
                      setNewAddress((prev) => ({ ...prev, city: val[0] || "" }))
                    }
                    options={newAddress.cityName ? [newAddress.cityName] : []}
                    selected={newAddress.cityName ? [newAddress.cityName] : []}
                    placeholder="City"
                    disabled
                  />
                  <Form.Control.Feedback>
                    Please select a valid City.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </div>
            <FormFooterButtons
              displayPreviousButton={true}
              previousButtonText={"Back"}
              handlePreviouButtonClick={handleBackClick}
              nextButtonText={"Continue"}
            />
          </Col>
          <Col
            md="5"
            lg="5"
            style={{
              justifyContent: "center",
              display: "flex",
              alignItems: "center",
            }}
          >
            <IllustrationImage />
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default ServiceLocationForm;
